import {Component, Input, OnInit} from "@angular/core";
import {Translations} from "@translations";

@Component({
	selector: "sim-room-legend-display",
	templateUrl: "./room-legend-display.component.html",
	styleUrls: ["./room-legend-display.component.scss"],
	standalone: false,
})
export class RoomLegendDisplayComponent implements OnInit {
	T = Translations;

	@Input() visibleLegendItems: {
		readyToConnect: boolean;
		offline: boolean;
		occupied: boolean;
		debriefing: boolean;
	} = {
		readyToConnect: true,
		offline: true,
		occupied: true,
		debriefing: true,
	};

	constructor() {}

	ngOnInit(): void {}
}
